import { Clock, type Tick } from "./clock";

export type LoopStep = (ctx: Tick) => void;

/** Запускаемый по requestAnimationFrame цикл с массивом степов. */
export class GameLoop {
  private readonly steps: LoopStep[];
  private readonly clock = new Clock();
  private running = false;
  private rafId: number | null = null;
  private readonly boundFrame: (now: number) => void;

  constructor(steps: LoopStep[]) {
    this.steps = steps;
    this.boundFrame = this.frame.bind(this);
  }

  /** Запускает цикл (no-op если уже запущен). */
  start(): void {
    if (this.running) return;
    this.running = true;
    this.clock.reset();
    this.rafId = requestAnimationFrame(this.boundFrame);
  }

  /** Останавливает цикл и отменяет pending RAF. */
  stop(): void {
    this.running = false;
    if (this.rafId != null) cancelAnimationFrame(this.rafId);
    this.rafId = null;
  }

  /** Возвращает true если цикл активен. */
  isRunning(): boolean {
    return this.running;
  }

  private frame(now: number): void {
    if (!this.running) return;
    const ctx = this.clock.tick(now);
    for (const step of this.steps) step(ctx);
    this.rafId = requestAnimationFrame(this.boundFrame);
  }
}
